import { render } from "./agentPartnerPlan.vue?vue&type=template&id=62fc6a59&scoped=true"
import script from "./agentPartnerPlan.vue?vue&type=script&lang=js"
export * from "./agentPartnerPlan.vue?vue&type=script&lang=js"

import "./agentPartnerPlan.vue?vue&type=style&index=0&id=62fc6a59&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fc6a59"]])

export default __exports__